import { Check } from 'lucide-react';

const SW = {
  light: ['#fafafa', '#10b981'], dark: ['#111111', '#10b981'], ocean: ['#0f1729', '#0ea5e9'],
  sunset: ['#131110', '#f97316'], emerald: ['#0d1711', '#10b981'], rose: ['#120d0e', '#f43f5e'],
};
const ACCENT = { light: '#2563eb', dark: '#334155', ocean: '#0284c7', sunset: '#f97316', emerald: '#059669', rose: '#e11d48' };

// Los 6 temas de color: paleta completa en Clásico, color de acento en Moderno
export const ColorThemeGrid = ({ themes, value, onChange, modern }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
    {Object.values(themes).map((t) => {
      const [bg, accent] = SW[t.value];
      const active = value === t.value;
      return (
        <button type="button" key={t.value} onClick={() => onChange(t.value)} data-testid={`theme-${t.value}`}
          className={`relative p-3 rounded-xl border-2 text-left transition-[border-color,transform] hover:scale-[1.02] ${active ? 'border-primary ring-2 ring-primary/30' : 'border-border hover:border-primary/50'}`}>
          {modern ? (
            <div className="h-10 rounded-lg mb-2" style={{ background: ACCENT[t.value] }} />
          ) : (
            <div className="h-16 rounded-lg mb-2 p-1.5 flex gap-1" style={{ background: bg }}>
              <div className="w-4 rounded-sm bg-white/10" />
              <div className="flex-1 flex flex-col gap-1"><div className="h-3 rounded-sm" style={{ background: accent }} /><div className="flex-1 rounded-sm bg-white/10 border border-black/5" /></div>
            </div>
          )}
          <p className="font-semibold text-sm">{t.name}</p>
          {!modern && <p className="text-xs text-muted-foreground">{t.description}</p>}
          {active && <span className="absolute top-2 right-2 w-5 h-5 bg-primary rounded-full grid place-items-center"><Check className="w-3 h-3 text-primary-foreground" /></span>}
        </button>
      );
    })}
  </div>
);
